import allTransitions from './transitions';
export * from './selectors';

export const transitionsReducer = () => allTransitions;

export const transitions = allTransitions;
